import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
// import "../src/styles/NavBar.css";
import React, { useState } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./pages/Home";
import About from "./pages/About";
import Career from "./pages/Career";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";
import Certifications from "./pages/Certifications";
import PhotoGallery from "./pages/PhotoGallery";
import Capability from "./pages/Capability";
import Portfolio from "./pages/Portfolio";
import { useNavigate } from 'react-router-dom';
import "./App.css"

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <nav className={`navbar ${menuOpen ? "menu-active" : ""}`}>
      <div className="navbar-left">
        <a href="/">
          <img src="logo.png" alt="Logo" className="navbar-logo animate-logo" />
        </a>
      </div>

      <div className={`navbar-center ${menuOpen ? "active" : ""}`}>
        <Link
          to="/"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          ABOUT
        </Link>
        {/* {/* <Link
          to="capability"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          CAPABILITY
        </Link> */}
        {/* <Link
          to="capability"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          CAPABILITY STATEMENTS
        </Link> */}
        <Link
          to="/"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          PROJECTS
        </Link>
        {/* <Link
          to="/certificate"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          OUR CERTIFICATION
        </Link> */}
        <Link
          to="/"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          GALLERY
        </Link>
        <Link
          to="/"
          className="nav-link"
          onClick={() => setMenuOpen(false)}
        >
          CONTACT US
        </Link>
      </div>

      {/* <div className="navbar-right">
        <div className="social-icons">
          <FaFacebookF className="icon social-icon" />
          <FaLinkedinIn className="icon social-icon" />
          <FaInstagram className="icon social-icon" /> */}
      {/* <FaSearch className="icon search-icon" /> */}
      {/* </div>
      </div> */}
      {/* <div className="navbat-left">
        <button
          className="button"
          onClick={() => (window.location.href = "tel:18888629190")}
        >
          Call Us
        </button>

         <button
      className="button"
      onClick={() => navigate('/contact')}
    >
      Become A Client
    </button>
      </div> */}
      <div
        className={`hamburger ${menuOpen ? "open" : ""}`}
        onClick={toggleMenu}
      >
        <div></div>
        <div></div>
        <div></div>
      </div>
    </nav>
  );
};

const App = () => (
  <>
    <Router>
      <NavBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/certificate" element={<Certifications />} />
        <Route path="/gallery" element={<PhotoGallery />} />
        <Route path="/career" element={<Career />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/capability" element={<Capability />} />
      </Routes>
    </Router>
    <Footer />
  </>
);

export default App;
